import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Filter Variant Remove"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-filter-variant-remove',
    templateUrl: './icon-filter-variant-remove.component.html',
    styleUrls: ['./icon-filter-variant-remove.component.scss'],
    standalone: false
})
export class IconFilterVariantRemoveComponent  {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
